import '@popperjs/core';
import 'bootstrap';

import { setDeviceId } from '@/front/device';
import '@/front/resize';
import '@/front/tooltip';

document.addEventListener('DOMContentLoaded', () => {
  setDeviceId();

  window.addEventListener('scroll', () => {
    document.body.classList.toggle('scrolled', window.scrollY >= 50);
  });

  const planIntervalSwitch = document.getElementById('plan-interval-switch') as HTMLInputElement | undefined;

  const plansMonth = document.getElementById('plans-month') as HTMLDivElement | undefined;
  const plansYear = document.getElementById('plans-year') as HTMLDivElement | undefined;

  if (planIntervalSwitch && plansMonth && plansYear) {
    planIntervalSwitch.addEventListener('click', () => {
      plansMonth.classList.toggle('active', !planIntervalSwitch.checked);
      plansYear.classList.toggle('active', planIntervalSwitch.checked);
    });
  }

  const confirmPasswordForm = document.getElementById('confirmPassword') as HTMLFormElement | null;

  if (confirmPasswordForm) {
    const password = confirmPasswordForm.elements.namedItem('password') as HTMLInputElement;
    const confirmPassword = confirmPasswordForm.elements.namedItem('confirmPassword') as HTMLInputElement;

    const validatePasswords = () => {
      if (password.value !== confirmPassword.value) {
        confirmPassword.setCustomValidity('Passwords do not match');
      } else {
        confirmPassword.setCustomValidity('');
      }
    };

    password.addEventListener('input', validatePasswords);
    confirmPassword.addEventListener('input', validatePasswords);

    confirmPasswordForm.addEventListener('submit', (e) => {
      if (!confirmPasswordForm.reportValidity()) e.preventDefault();
    });
  }
});
